/**
 * BookHeading — the phase-coloured page header shared by every Operations book.
 * It renders the book's portal-vocabulary title (from `OPERATIONS_PHASES`, the
 * single source of truth, so the rename lives in one place) behind a short
 * accent rule in the phase colour. The right slot (`children`) carries each
 * book's own count node, testid included, so existing count assertions hold.
 */

import type { ReactNode } from "react";
import { PHASE_BY_KEY } from "@/lib/operations-phases";

export function BookHeading({
  phaseKey,
  children,
}: {
  /** Route key of the book (e.g. "placed") — names + colours the header. */
  phaseKey: string;
  /** Right-aligned slot — the book's count span (keep its data-testid here). */
  children?: ReactNode;
}) {
  const phase = PHASE_BY_KEY[phaseKey];
  return (
    <header className="mb-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <span
          className="h-6 w-1 shrink-0 rounded-full"
          style={{ backgroundColor: phase?.accent }}
          aria-hidden="true"
        />
        <h2 className="text-xl">{phase?.label ?? phaseKey}</h2>
      </div>
      {children}
    </header>
  );
}
